import AppPageTitle from '@/components/AppPageTitle';
import AppTable from '@/components/AppTable';
import AppTableQuery from '@/components/AppTableQuery';
import { Space } from 'antd';
import React, { useState } from 'react';
import usePaginatedQuery from '@/hooks/usePaginatedQuery';
import { getHistoryMultipleMode } from '@/services/customer_care.service';
import dayjs from 'dayjs';
import { formatDate, columnSorter, formatNumber } from '@/utils/formatters';
import { getActiveBadge } from '@/utils/getActiveBadge';

const columns = [
  {
    title: 'ISDN',
    dataIndex: 'isdn',
    key: 'isdn',
    sorter: columnSorter('isdn'),
    render: (isdn) => (isdn ? <span>{isdn}</span> : '-'),
  },
  {
    title: 'Play Time',
    dataIndex: 'start_time',
    key: 'start_time',
    sorter: columnSorter('start_time'),
    render: (data) => formatDate(data),
  },
  {
    title: 'Points Earned',
    dataIndex: 'point_round',
    key: 'point_round',
    sorter: columnSorter('point_round'),
    render: (text) => (text ? formatNumber(text) : '0'),
  },
  {
    title: 'Hearts Used',
    dataIndex: 'heart',
    key: 'heart',
    sorter: columnSorter('heart'),
    render: (text) => (text ? formatNumber(text) : '0'),
  },
  {
    title: 'Result',
    dataIndex: 'result',
    key: 'result',
    render: (result) =>
      getActiveBadge(result === 1, {
        activeText: 'Win',
        inactiveText: 'Lose',
      }),
    sorter: columnSorter('result'),
  },
];
const START_DATE = dayjs().startOf('week').format('YYYY-MM-DD');
const END_DATE = dayjs().format('YYYY-MM-DD');

function MultiplayerMode() {
  const [isdn, setIsdn] = useState(null);
  const [result, setResult] = useState(null);
  const [date, setDate] = useState([START_DATE, END_DATE]);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(1);
  const offset = (pageIndex - 1) * pageSize + 1;

  const [query, setQuery] = useState({
    isdn: null,
    result: null,
    start_date: date[0],
    end_date: date[1],
  });

  const {
    data: historyData,
    isLoading,
    refetch,
    isRefetching,
  } = usePaginatedQuery(
    () =>
      getHistoryMultipleMode({
        ...query,
        limit: pageSize,
        offset: offset,
      }),
    ['solo-mode-history', query, pageSize, offset]
  );

  const handleQuery = () => {
    setQuery({
      isdn: isdn,
      result: result,
      start_date: date[0],
      end_date: date[1],
    });
    setPageIndex(1);
  };

  const handleReset = () => {
    setIsdn(null);
    setResult(null);
    setDate([START_DATE, END_DATE]);
    setQuery({
      isdn: null,
      result: null,
    });
    setPageIndex(1);
  };

  // const formatData = useMemo(() => {
  //   return historyData?.data?.filter((item) => item.isdn);
  // }, [historyData]);

  return (
    <Space direction="vertical" className="w-full">
      <AppPageTitle title="Multiplayer Mode Play History" />

      {/* <AppTableControl hasSelect={false} date={date} setDate={setDate} noStyle /> */}
      <AppTableQuery
        searchValue={isdn}
        setSearchValue={setIsdn}
        filterOptions={[
          { label: 'All', value: null },
          { label: 'Win', value: 1 },
          { label: 'Lose', value: 2 },
        ]}
        filterLabel="Result"
        setSelectedFilter={setResult}
        selectedFilter={result}
        searchPlaceholder="Search by ISDN"
        filterPlaceholder="Result"
        handleQuery={handleQuery}
        handleReset={handleReset}
        hasDatePicker
        rangePicker
        time={date}
        setTime={setDate}
      />
      <AppTable
        columns={columns}
        dataSource={historyData?.data}
        totalItems={historyData?.total}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPageChange={(page, size) => {
          setPageIndex(page);
        }}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
        }}
        loading={isLoading || isRefetching}
        onRefresh={refetch}
      />
    </Space>
  );
}

export default MultiplayerMode;
